// Contract proposes 200 for TOO_MANY_ITEMS but marks it unconfirmed (VT-9377) —
// revisit once the backend confirms the real cap.
export const MAX_BULK_ITEM_REFS = 200;

const ITEM_REF_KEY_BUILDERS = {
  SHRED_PARAGRAPH: ({ paragraphId }) => `${paragraphId}`,
  SHRED_SENTENCE: ({ paragraphId, sentenceStartOffset }) =>
    `${paragraphId}:${sentenceStartOffset}`,
  ACRONYM_ENTRY: ({ name, paragraphIndex, location }) =>
    `${name}|${paragraphIndex ?? ""}|${location ?? ""}`,
  COMPARE_RESULT: ({ sheetName, rawStartIndex }) =>
    `${sheetName}:${rawStartIndex}`,
  OUTLINE_SECTION: ({ outlineItemId }) => `${outlineItemId}`,
};

// FE-internal cache key only — never sent to the server. The server owns the
// real anchor (plan §4); the FE must never construct or see one (contract §0).
export const buildItemRefKey = (surface, itemRef = {}) => {
  const builder = ITEM_REF_KEY_BUILDERS[surface];
  if (!builder) {
    throw new Error(`Unknown comment surface: ${surface}`);
  }
  return builder(itemRef);
};

export const buildDiscussionKey = (surface, containerId, itemRef) =>
  `${surface}:${containerId}:${buildItemRefKey(surface, itemRef)}`;

export const buildCountsKey = (surface, containerId) =>
  `${surface}:${containerId}`;
